/**
 * Facets implementation
 */

import { presetFilterServices } from "./utils";

const CSS = {
	HEAD: {
		close: 'kuExpand',
		open: 'kuCollapse'
	},
	NAME: {
		close: 'kuFilterCollapse',
		more: 'kuFilterShowAll',
	},
};

klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "addFacetsOnLandingPage",
	fire: function () {

		/** Load filters template */
		klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateFilters"), "filters", true);

		klevu.search.landing.getScope().chains.template.events.add({
			name: "initializeFilterLeft",
			fire: function (data, scope) {
				klevu.search.modules.facets.base.attachFacetItemsClickEvent(scope.kScope);
				var $filters = document.querySelector('.kuFilters');
				if ($filters) {
					var $filterItems = $filters.querySelectorAll('.kuFilterBox.klevuFilter:not([data-filter="klevu_price"])');

					$filterItems.forEach(function($filterEl, i) {
						const $filterSelected = $filterEl.querySelectorAll('.kuSelected');
						const hasSelected = !!$filterSelected.length;
						function open() {
							$filterEl.querySelector('.kuFilterHead').classList.remove(CSS.HEAD.close);
							$filterEl.querySelector('.kuFilterHead').classList.add(CSS.HEAD.open);
							$filterEl.querySelector('.kuFilterNames').classList.remove(CSS.NAME.close);
						}

						function close() {
							$filterEl.querySelector('.kuFilterHead').classList.remove(CSS.HEAD.open);
							$filterEl.querySelector('.kuFilterHead').classList.add(CSS.HEAD.close);
							$filterEl.querySelector('.kuFilterNames').classList.add(CSS.NAME.close);
							$filterEl.querySelector('.kuFilterNames').classList.remove(CSS.NAME.more);
						}
						// make the filter facets collapse for index more than 3
						if (i < 3) {
							open();
							if (!hasSelected) {
								// Show less
								$filterEl.querySelector('.kuFilterNames').classList.remove(CSS.NAME.more);
							}
						}

						if ($filterSelected.length) {
							const $filterSelectedLast = $filterSelected[$filterSelected.length - 1];
							const isSelectedOutOfDisplay = $filterSelectedLast && parseInt($filterSelectedLast.dataset.index) > 3;
							isSelectedOutOfDisplay && $filterEl.querySelector('.kuFilterNames').classList.add(CSS.NAME.more);
						} else if (i >=3) {
							close();
						}
					});
				}
			}
		});

		klevu.search.landing.getScope().template.setHelper("eachFilter", function(filters, callback) {
			filters.reduce(function(acc, cur) {
				const isPrice = cur.key === "klevu_price";
				const isCustomAndQuery = presetFilterServices().exists(cur.key);
				const hasManyOptions = cur.options && (cur.options.length > 1 || (cur.options.length === 1 && cur.options.find((filter) => filter.selected)));
				(isCustomAndQuery || isPrice || hasManyOptions) && acc.push(cur);
				return acc;
			}, []).forEach(callback);
		});

		klevu.search.landing.getScope().template.setHelper("initClass", function(key, elementClass, defaultClass) {
			return klevu.getObjectPath(window.klevuElementClass || {}, `${elementClass}[${key}]`, defaultClass);
		});
	}
});



// WEBPACK FOOTER //
// ./klevu/klevu-landing-filter-left.js